export default "/assets/images/mila-circle.png?20b1ef576763e780e9e0754b5945decd";